import React, { useEffect, useState } from "react";

const AddLectures = ({ subjectId, setSub, movieTypes, sub }) => {
  const [forms, setForms] = useState(sub || []); // Use the `sub` from the parent if available.
  console.log("sub", sub[0], movieTypes ,!sub || sub.length === 0);

  useEffect(() => {
    setForms(sub);
  }, [sub]);
  // useEffect(() => {
  //   if (!sub || sub.length === 0) {
  //     const totalUnits = parseInt(
  //       localStorage.getItem("totalUnits") || "1",
  //       10
  //     );
  //     console.log('inside',movieTypes);
      
  //     const initialForms = Array.from({ length: totalUnits }, (_, index) => ({
  //       unit_id: index + 1,
  //       lectures: movieTypes?.map(() => ({
  //         movie_type: "",
  //         title: "",
  //         file_path: "",
  //         jwp_media: "",
  //       })),
  //     }));
  //     setForms(initialForms);
  //     setSub(initialForms);
  //   }
  // }, [movieTypes, sub, setSub]);
 



  // Every unit starts with one row per category. "Add video" adds more rows,
  // so a unit can carry several videos of the same category (high school
  // English has up to four Resources videos in a unit); those are kept here.
  useEffect(() => {
    const base =
      sub && sub.length > 0
        ? sub
        : Array.from(
            { length: parseInt(localStorage.getItem("totalUnits") || "1", 10) },
            (_, index) => ({ unit_id: index + 1, lectures: [] })
          );
    const next = base.map((unit) => {
      const lectures = unit.lectures || [];
      const rows = Math.max(movieTypes?.length || 0, lectures.length, 1);
      return {
        ...unit,
        lectures: Array.from({ length: rows }, (_, i) => ({
          movie_type: lectures[i]?.movie_type || "",
          title: lectures[i]?.title || "",
          file_path: lectures[i]?.file_path || "",
          jwp_media: lectures[i]?.jwp_media || "",
        })),
      };
    });
    setForms(next);
    // Only push up a real change; pushing every time re-ran this effect forever.
    if (JSON.stringify(next) !== JSON.stringify(sub)) setSub(next);
  }, [movieTypes, sub, setSub]);

  const update = (updatedForms) => {
    setForms(updatedForms);
    setSub(updatedForms); // Updates the parent state
  };

  const handleLectureInputChange = (e, unitIndex, movieIndex) => {
    const { name, value } = e.target;
    const updatedForms = [...forms];
    updatedForms[unitIndex].lectures[movieIndex] = {
      ...updatedForms[unitIndex].lectures[movieIndex],
      [name]: value,
    };
    update(updatedForms);
  };

  const addVideo = (unitIndex) =>
    update(forms.map((f, i) => (i === unitIndex ? { ...f, lectures: [...f.lectures, { movie_type: "", title: "", file_path: "", jwp_media: "" }] } : f)));

  const removeVideo = (unitIndex, movieIndex) =>
    update(forms.map((f, i) => (i === unitIndex ? { ...f, lectures: f.lectures.filter((_, j) => j !== movieIndex) } : f)));

  return (
    <div className="accordion" id="accordionExample">
      {forms.map((form, i) => (
        <div key={i} className="accordion-item">
          <h2 className="accordion-header" id={`heading-${i}`}>
            <button
              className={`accordion-button ${i === 0 ? "" : "collapsed"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${i}`}
              aria-expanded={i === 0}
              aria-controls={`collapse-${i}`}
            >
              Unit {i + 1}
            </button>
          </h2>
          <div
            id={`collapse-${i}`}
            className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
            aria-labelledby={`heading-${i}`}
            data-bs-parent="#accordionExample"
          >
            <div className="modal-body">
              <div className="row">
                <input type="hidden" name="unit_id" value={form.unit_id} />
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{width: '60px'}}>S.NO</th>
                      <th style={{width: '28%'}}>Category</th>
                      <th>Title <span className="text-muted fw-normal">(optional, shown to students)</span></th>
                      <th style={{width: '24%'}}>Video ID</th>
                      <th style={{width: '44px'}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {form.lectures.map((lecture, movieIndex) => (
                      <tr key={`${form.unit_id}-${movieIndex}`}>
                        <td className="text-center">{movieIndex + 1}</td>
                        <td>
                          <select
                            className="form-select"
                            name="movie_type"
                            value={lecture.movie_type}
                            onChange={(e) =>
                              handleLectureInputChange(e, i, movieIndex)
                            }
                          >
                            <option value="">Select Category</option>
                            {movieTypes.map((type) => (
                              <option key={type.id} value={type.id}>
                                {type.file_type}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            placeholder="e.g. Poem reading"
                            value={lecture.title || ""}
                            onChange={(e) =>
                              handleLectureInputChange(e, i, movieIndex)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="jwp_media"
                            placeholder="e.g. RkhvL9gf"
                            value={lecture.jwp_media}
                            onChange={(e) =>
                              handleLectureInputChange(e, i, movieIndex)
                            }
                          />
                        </td>
                        <td className="text-center align-middle">
                          {movieIndex >= Math.max(movieTypes?.length || 0, 1) && (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              title="Remove this video"
                              onClick={() => removeVideo(i, movieIndex)}
                            >
                              ×
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => addVideo(i)}
                  >
                    + Add video
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddLectures;
